import * as React from 'react';
import GroupContainer, {GroupContainerProps} from 'containers/GroupContainer';
import {WebinarObject} from 'api/webinar/types';

export type FormContainerProps =
  React.PropsWithChildren<GroupContainerProps<WebinarObject>> & {
};

/**
 *
 * @param {FormContainerProps} props
 * @return {React.ReactElement<FormContainerProps>}
 * @constructor
 */
export default function FormContainer(
    props: FormContainerProps,
): React.ReactElement<FormContainerProps> {
  return (
    <GroupContainer<WebinarObject>
      {...props}
    />
  );
}
